// extracted by css-extract-rspack-plugin
export default {"root":"YnLA6B","white":"WAUhBL","themed":"WmopFM"};